function tzOffsetMinutes({
  utcMs,
  timeZone,
}: {
  readonly utcMs: number;
  readonly timeZone: string;
}): number {
  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone,
    hourCycle: "h23",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  }).formatToParts(new Date(utcMs));
  const get = (t: string) =>
    Number(parts.find((p) => p.type === t)?.value ?? "0");
  const asIfUtc = Date.UTC(
    get("year"),
    get("month") - 1,
    get("day"),
    get("hour"),
    get("minute"),
    get("second"),
  );
  return (asIfUtc - utcMs) / 60000;
}
export function zonedWallTimeToUtc({
  year,
  month,
  day,
  hour,
  minute,
  timeZone,
}: {
  readonly year: number;
  readonly month: number;
  readonly day: number;
  readonly hour: number;
  readonly minute: number;
  readonly timeZone: string;
}): number {
  const naive = Date.UTC(year, month - 1, day, hour, minute, 0);
  const offset1 = tzOffsetMinutes({
    utcMs: naive,
    timeZone,
  });
  const guess = naive - offset1 * 60000;
  const offset2 = tzOffsetMinutes({
    utcMs: guess,
    timeZone,
  });
  return naive - offset2 * 60000;
}
export function dateParts({
  at,
  timeZone,
}: {
  readonly at: Date;
  readonly timeZone: string;
}): {
  readonly y: number;
  readonly m: number;
  readonly d: number;
} {
  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).formatToParts(at);
  const get = (t: string) =>
    Number(parts.find((p) => p.type === t)?.value ?? "0");
  return { y: get("year"), m: get("month"), d: get("day") };
}
